import { render, staticRenderFns } from "./manage-mass-update.vue?vue&type=template&id=6f22f542&scoped=true"
import script from "./manage-mass-update.vue?vue&type=script&lang=js"
export * from "./manage-mass-update.vue?vue&type=script&lang=js"
import style0 from "./manage-mass-update.vue?vue&type=style&index=0&id=6f22f542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f22f542",
  null
  
)

export default component.exports